// Texas state configuration for the Accident Aid platform.
// Mirrors backend/state_config/states/texas/*. All Texas-specific identity,
// contact, SEO, routing, cities and feature flags live here so the app stays
// state-agnostic. Adding a state = adding a sibling module + registry entry.

export const texas = {
  code: "TX",

  // Identity / branding
  brand: "Texas Accident Aid",
  brandTeam: "Texas Accident Aid Team",
  monogram: "TX",
  tagline: "Help. When you need it most.",
  domain: "texasaccidentaid.com",
  publicSiteUrl: "https://texasaccidentaid.com/",

  // State descriptors used in copy
  stateName: "Texas",
  stateAdj: "Texas",
  stateDemonym: "Texans",
  serviceTagline: "SERVING ALL OF TEXAS",

  // Routing
  cityRoute: "texas-cities",
  citiesNavLabel: "Texas Cities",

  // Contact
  phone: "(216) 245-5967",
  phoneTel: "12162455967",
  phoneE164: "+1-216-245-5967",

  // Analytics — measurement ID is injected at build via REACT_APP_GA4_ID (empty = disabled)
  gaId: process.env.REACT_APP_GA4_ID || "",

  // SEO defaults + schema.org values
  seo: {
    defaultTitle: "Texas Accident Aid | Free 24/7 Help for Accident Victims",
    defaultDescription:
      "Injured in Texas? Get a free, no-obligation case review with experienced local attorneys. Available 24/7. No fees unless you win.",
    siteName: "Texas Accident Aid",
    areaServed: "Texas",
    priceRange: "Free consultation",
  },

  // Ordered city list — Footer uses the first 8, CitiesPreview uses the first 10.
  cities: [
    { name: "Houston", slug: "houston", county: "Harris County" },
    { name: "Dallas", slug: "dallas", county: "Dallas County" },
    { name: "San Antonio", slug: "san-antonio", county: "Bexar County" },
    { name: "Austin", slug: "austin", county: "Travis County" },
    { name: "Fort Worth", slug: "fort-worth", county: "Tarrant County" },
    { name: "El Paso", slug: "el-paso", county: "El Paso County" },
    { name: "Arlington", slug: "arlington", county: "Tarrant County" },
    { name: "Corpus Christi", slug: "corpus-christi", county: "Nueces County" },
    { name: "Plano", slug: "plano", county: "Collin County" },
    { name: "Lubbock", slug: "lubbock", county: "Lubbock County" },
  ],

  // Feature flags — mirror backend flags. Reserved for future clusters/modules
  // (some not yet consumed by the UI).
  flags: {
    oilfieldAccidents: true,
    constructionAccidents: true,
    dramShop: true,
    umUim: true,
    medMalCaps: true,
    hurricaneContent: true,
    noFault: false,
    skiAccidents: false,
  },
};
